import React from 'react';
import PropTypes from 'prop-types';

import UserHeader from '../UserHeader/UserHeader';
import UploadMenu from '../UploadMenu/UploadMenu';
import WidgetUsersOnline from '../WidgetUsersOnline/WidgetUsersOnline';

const MainHeader = ({
  sidebarVisibility, subheader, mobileMenuOpen, onMobileMenuToggle
}) => {
  return (
    <div
      className={`flex flex-col fixed right-0 top-0 z-[3] bg-white dark:bg-background-dark
      shadow-[0_10px_30px_0_rgba(82,63,105,0.08)] transition-all duration-300 ease-out
      ${!sidebarVisibility ? 'left-0 md:left-[72px]' : 'left-0 md:left-[260px]'}`}
    >
      <div className="px-[12px] h-[56px] md:px-[25px] md:h-[65px] flex flex-row items-center justify-between">
        <div className="flex items-center gap-[10px]">
          <button
            type="button"
            aria-label={mobileMenuOpen ? 'Close navigation' : 'Open navigation'}
            aria-expanded={mobileMenuOpen}
            className="w-[40px] h-[40px] -ml-[4px] flex items-center justify-center rounded-[8px]
            text-[#64748b] hover:bg-[#f1f5f9] dark:text-[#94a3b8] dark:hover:bg-[#1b263b] md:hidden"
            onClick={onMobileMenuToggle}
          >
            {mobileMenuOpen ? (
              <svg viewBox="0 0 24 24" className="w-[22px] h-[22px]" fill="none" aria-hidden="true">
                <path d="M6 6l12 12M18 6 6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              </svg>
            ) : (
              <svg viewBox="0 0 24 24" className="w-[22px] h-[22px]" fill="none" aria-hidden="true">
                <path d="M4 7h16M4 12h16M4 17h16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              </svg>
            )}
          </button>
          <div className="hidden md:block">
            <WidgetUsersOnline />
          </div>
        </div>
        <div className="flex flex-row items-center min-w-0">
          <UploadMenu />
          <div className="w-[1px] bg-[#eff2f5] dark:bg-[#1b263b] mx-[8px] md:mx-[17px] h-[30px] md:h-[35px]" />
          <UserHeader />
        </div>
      </div>
      {subheader
        && (
        <div
          className="h-[56px] md:h-[55px] overflow-x-auto overflow-y-hidden customScroll
          [&>*]:min-w-max"
        >
          {subheader}
        </div>
        )}
    </div>
  );
};

MainHeader.propTypes = {
  sidebarVisibility: PropTypes.bool,
  subheader: PropTypes.node,
  mobileMenuOpen: PropTypes.bool,
  onMobileMenuToggle: PropTypes.func,
};

MainHeader.defaultProps = {
  sidebarVisibility: true,
  subheader: undefined,
  mobileMenuOpen: false,
  onMobileMenuToggle: () => {}
};

export default MainHeader;
